export default __webpack_public_path__ + "static/fredrikstadkino-b9c2e373fff4285c997b3363a04ef4e2.png";